import styled, { css, DefaultTheme } from 'styled-components'

import { AlertBarVariant } from './AlertBar'

interface VariantProps {
  $variant: AlertBarVariant
}

const variantStyle = (theme: DefaultTheme, variant: AlertBarVariant) => {
  switch (variant) {
    case 'warning':
      return css`
        background-color: ${theme.colors.yellowL0}40;
      `
    case 'error':
      return css`
        background-color: ${theme.colors.error}40;
      `
    case 'success':
    default:
      return css`
        background-color: ${theme.colors.primary}40;
      `
  }
}

const variantTextStyle = (theme: DefaultTheme, variant: AlertBarVariant) => {
  switch (variant) {
    case 'warning':
      return css`
        color: ${theme.colors.yellowL0};
      `
    case 'error':
      return css`
        color: ${theme.colors.error};
      `
    case 'success':
    default:
      return css`
        color: ${theme.colors.primaryL1};
      `
  }
}

export const Container = styled.div<VariantProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  border-radius: 8px;
  box-sizing: border-box;
  ${({ theme, $variant }) => variantStyle(theme, $variant)}
`

export const Message = styled.span<VariantProps>`
  ${({ theme }) => theme.fonts.titleXS}
  text-align: center;
  ${({ theme, $variant }) => variantTextStyle(theme, $variant)}
`
